import {
  type DerivedPointVisualizationOption,
  POINT_VISUALIZATION_OPTIONS,
} from '../../WorkspaceDrawer/Settings/types';

/**
 * Line Aggregations are going to be used to determine the primary line. This will changing the querying under the hood as 'AVERAGE' and 'MEAN' will be bucketing queries.
 */
export type LineAggregations =
  | 'SAMPLED' // this is the default RSDQ response
  | 'AVERAGE'; // this is the default bucketing response

export const SAMPLING_FALLBACK_ERROR_MESSAGE =
  'Some lines in this chart may be downsampled. Zoom into specific areas to view all data points.';

export function determineAggregationType({
  hasUnsupportedConfig,
  hasRenderError,
  pointVisualizationMethod,
}: {
  hasUnsupportedConfig: boolean;
  hasRenderError: boolean;
  pointVisualizationMethod: DerivedPointVisualizationOption;
}): LineAggregations {
  if (hasUnsupportedConfig || hasRenderError) {
    return 'SAMPLED';
  }

  return pointVisualizationMethod ===
    POINT_VISUALIZATION_OPTIONS.BucketingGorilla
    ? 'AVERAGE'
    : 'SAMPLED';
}
